class AsyncJSLoader {
    public static getAMDLibrary = _.memoize((libraryUrl: string, globalVariable?: string) =>
        _.once((overridenLibraryUrl?: string) => {
            libraryUrl = overridenLibraryUrl || libraryUrl;
            console.log('Loading', libraryUrl);
            return new Promise(resolve =>
                loadScripts([libraryUrl], (lib: string) => resolve((window[globalVariable] || lib))));
        }));
}

/**
 * define all async libraries here
 */
export const googleMapsLib = AsyncJSLoader.getAMDLibrary('https://maps.googleapis.com/maps/api/js');

export const stripeLib = AsyncJSLoader.getAMDLibrary('https://js.stripe.com/v2/', 'Stripe');
export const reamazeLib = AsyncJSLoader.getAMDLibrary('https://d3itxuyrq7vzpz.cloudfront.net/assets/reamaze.js', 'Reamaze');
export const clipboardLib = AsyncJSLoader.getAMDLibrary('https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/1.5.5/clipboard.min.js', 'Clipboard');




// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AsyncJSLoader.ts